/* eslint-disable @typescript-eslint/no-floating-promises */
"use client";
import React, { useCallback, useEffect } from "react";

import CustomTabTrigger from "@/components/CustomTabTrigger/CustomTabTrigger";
import { Tabs, TabsList } from "@/components/ui/tabs";

import { ITabsValue } from "@/interfaces/TabbedMaps/TabbedMaps";
import MapboxMap from "../MapboxMap/MapboxMap";

import { IMainMapMarker } from "@/interfaces/MapboxMap/MapboxMap";
import Typography from "../Typography/Typography";
import { getDistanceAndDuration } from "@/common/getDistanceAndDuration";

import WalkingIcon from "@/components/Icons/WalkingIcon";

export default function TabbedMaps({
  tabbedMaps,
  mainLocation,
}: {
  tabbedMaps: ITabsValue[];
  mainLocation: IMainMapMarker;
}) {
  const [source, setSource] = React.useState<string>("");
  const [distanceDuration, setDistanceDuration] = React.useState<{
    distanceInKilometers: number;
    durationInMinutes: number;
  }>();

  function getMapCoordinatesById(id: string): { latitude: number; longitude: number } {
    for (const item of tabbedMaps) {
      if (item.id === id) {
        return item.location.mapCoordinates;
      }
    }
    return { latitude: 0, longitude: 0 };
  }

  const endMapCoordinates = getMapCoordinatesById(source);

  useEffect(() => {
    setSource(tabbedMaps[0].id);
  }, [tabbedMaps]);

  const fetchData = useCallback(async () => {
    try {
      const result = await getDistanceAndDuration(mainLocation.mapCoordinates, endMapCoordinates);
      if (result) {
        setDistanceDuration(result);
      }
    } catch (error) {
      console.error("Error fetching distance and duration:", error);
    }
  }, [endMapCoordinates, mainLocation.mapCoordinates]);

  function handleSource(id: string) {
    setSource(id);
  }
  useEffect(() => {
    fetchData();
  }, [fetchData]);
  return (
    <div className="flex cmd:px-6 flex-col w-full cmd:max-w-80.68 mx-auto gap-4 cmd:gap-12">
      <Tabs defaultValue={tabbedMaps[0]?.id}>
        <TabsList className="flex overflow-x-scroll cmd:overflow-hidden cmd:flex-wrap cmd:gap-y-4 self-stretch items-center gap-x-6 bg-transparent justify-normal cmd:justify-center">
          {tabbedMaps.map((tab) => (
            <CustomTabTrigger className="px-4" key={tab.id} value={tab.id} onClick={handleSource}>
              {tab.tabLabel}
            </CustomTabTrigger>
          ))}
        </TabsList>
      </Tabs>
      <div className="h-34.5 w-full bg-slate-400 relative">
        {mainLocation && (
          <MapboxMap
            mainMapMarker={mainLocation}
            mainMarkerImageUrl={mainLocation.markerImageUrl}
            sourceMarkers={tabbedMaps}
            source={source}
          />
        )}
        <div className="bg-white text-black px-12 whitespace-nowrap py-2 rounded-full absolute bottom-20 c2xs:bottom-10 left-1/2 transform -translate-x-1/2 -translate-y-3/4 flex flex-row items-center justify-center gap-2">
          <WalkingIcon color="#000000" style={{ height: "24", width: "24", cursor: "pointer" }} />
          <Typography
            variant="button-label"
            className="!text-base font-roboto font-medium"
          >{`${distanceDuration?.durationInMinutes} MINUTES - ${distanceDuration?.distanceInKilometers.toFixed(1)}KM`}</Typography>
        </div>
      </div>
    </div>
  );
}
